import styled from 'styled-components';

export const LayerControlContainer = styled.div`
  position: absolute;
  padding: 0px;
  border: none;
  right: 17px;
  max-height: ${props => (props.show ? '500px' : '0px')};
  max-width: ${props => (props.show ? '500px' : '0px')};
  overflow: hidden;
  top: 24px;
  z-index: 1;
  transition: max-width 0.5s ease 0s, max-height 0.5s ease 0s;
`;

export const LayerControlLabel = styled.h6`
  padding-left: 8px;
  background-color: rgb(34, 34, 34);
  color: rgb(255, 255, 255);
  font-weight: bold;
`;

export const LayerControlListContainer = styled.div`
  max-height: 35vh;
  overflow-y: scroll;
`;

export const LayerControlListElement = styled.div`
  position: relative;
  text-align: initial;
`;
